export default __webpack_public_path__ + "static/media/azharAli.41920adf.png";